import contentfulGql from 'js/lib/contentfulGql';

export const orgLandingContentfulQuery = contentfulGql`
    fragment Image on Asset {
        width
        height
        url
        description
    }

    query OrgLandingContentful($orgSlug: String!, $preview: Boolean, $locale: String!) {
        orgHomepageOrgLandingCollection(where: {slug: $orgSlug }, limit: 1, preview: $preview, locale: $locale) {
            items {
                slug
                name
                headline
                subHeadline
                tagline
                getStartedLabel
                headlineTextAlign
                textColor
                brandColor
                brandTextColor
                logosCollection {
                    items {
                        ...Image
                    }
                }
                bannerImage {
                    ...Image
                }
                bannerBody
                bannerBodyFont
                bannerBodyFirstElementFont
                  
                sponsorLogosCollection {
                    items {
                        ...Image
                    }
                }
                
                noProgramsErrorTitle
                noProgramsErrorBody

                taglineLoggedIn
                logosLoggedInCollection {
                    items {
                        ...Image
                    }
                }
                programListHeader
            }
        }
    }
`;
